import { MainProductData } from 'utils/types';
import { StyledMainProduct } from '../style';

function BundleMainProduct({
  quantityDisplay,
  strokedSaleQuantity,
  images = { product: '' },
  salePercentage = 0,
}: MainProductData) {
  return (
    <StyledMainProduct title={quantityDisplay}>
      <img
        src={images.product}
        className="mainPic main-product__main-img"
        alt="main product"
      />
      <div className="main-product__header">
        {(salePercentage > 0 || strokedSaleQuantity) && (
          <p className="stroked">{strokedSaleQuantity}</p>
        )}
        <h2 className="quantity">{quantityDisplay}</h2>
      </div>
    </StyledMainProduct>
  );
}

export default BundleMainProduct;
